import { Route, Routes } from 'react-router-dom'
import { hasPermission } from 'store'
import NoAccess from 'components/NoAccess'
import LookupPage from './Page'

export default function PersonLookupIndex() {
  if (!hasPermission('people.people')) return <NoAccess />
  return (
    <Routes>
      <Route path="/*" element={<LookupPage />} />
    </Routes>
  )
}
